import React, { useEffect, useState } from 'react';
import {
    ReferenceInput,
    SimpleFormIterator,
    SimpleForm,
    FormDataConsumer,
    ReferenceArrayInput,
    Loading,
    useDataProvider,
    TextField,
    useResourceContext,
    ReferenceField
} from 'react-admin';
import { DeliveryRenderer } from '../Course/Tabs/CourseDeliveriesTabs';
import { ModuleTitleRenderer } from '../Course/CourseInputs';
import { toSavedRepresentation } from '../../utils/courseDelivery';
import { useAzureADGroups } from '../../msal/useAzureADGroups';
import { ReadOnlyContext } from '../../lib/context/ReadOnlyContext';
import {
    ArrayInput,
    AutocompleteInput,
    BooleanInput,
    RadioButtonGroupInput,
    SelectArrayInput,
    TextInput as VeroTextBox,
    DateInput
} from '../../lib/wrappers/Inputs';

import { Typography, Divider, Box, Chip } from '@mui/material';
import { EditToolbar } from '../../layout/EditToolbar';

var titleStyle = { color: "#AE223F" }
var labelStyle = {
    color: '#000000',
    opacity: 0.8,
    padding: 0,
    fontsize: 1,
    fontweight: 400, lineheight: 1, letterspacing: 0.00938
}

const TextInput = (props) => {
    return <VeroTextBox {...props} className="input-padding-fix" />
}

const CourseInstanceInputs = (props) => {
    const { canEditCourseAndModule, isSuperAdmin } = useAzureADGroups();
    const { isCreate } = props;
    const resource = useResourceContext();
    const canEdit = isSuperAdmin || (resource === 'CourseInstance' && canEditCourseAndModule);
    return (
        <ReadOnlyContext.Provider value={!canEdit}>
            <SimpleForm toolbar={<EditToolbar />}>
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Typography variant="h6" style={titleStyle} sx={{ height: '40px', borderBottom: '1px solid #AE223F', marginBottom: '15px' }}>
                            Course Instance | <small><TextField source="id" label={false} /></small>
                        </Typography>
                    </Box>
                </Box>
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="General" /></b></Divider>
                    </Box>
                </Box>
                <Box display="flex" width={1}>
                    <Box flex={5} ml="0.5em">
                        <BooleanInput source="isAssociateCourse" />
                    </Box>
                    <Box flex={5} ml="0.5em">
                        <BooleanInput source="finalYear" />
                    </Box>
                </Box>
                <Box display="flex" width={1}>
                    <Box flex={8}>
                        <FormDataConsumer>
                            {({ formData }) => (
                                <CourseCodeSelector
                                    isAssociateCourse={formData.isAssociateCourse}
                                />
                            )}
                        </FormDataConsumer>
                    </Box>
                    <Box flex={2} ml="0.5em">
                        <TextInput source="quercusCode" fullWidth />
                    </Box>
                    <Box flex={2} ml="0.5em">
                        <TextInput source="courseYear" fullWidth />
                    </Box> 
                </Box>
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Delivery" /></b></Divider>
                    </Box>
                </Box>
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <FormDataConsumer>
                            {({ formData, ...rest }) => {
                                return formData.courseCode ? (
                                    <DeliverySelector
                                        isAssociateCourse={formData.isAssociateCourse}
                                        courseCode={formData.courseCode}
                                        isCreate={isCreate}
                                        formData={formData}
                                    />
                                ) : null;
                            }}
                        </FormDataConsumer>
                    </Box>
                </Box>
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Modules" /></b></Divider>
                    </Box>
                </Box>
                <FormDataConsumer>
                    {({ formData, ...rest }) =>
                        formData.courseCode ? (
                            <ModulesSelector
                                isAssociateCourse={formData.isAssociateCourse}
                                courseCode={formData.courseCode}
                            />
                        ) : null
                    }
                </FormDataConsumer>
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Years and Dates" /></b></Divider>
                    </Box>
                </Box>
                <ArrayInput source="yearsAndDates" fullWidth label={false}>
                    <SimpleFormIterator disableReordering fullWidth>
                        {/* 
                        //Amitabh Date picker 
                    <TextInput
                        source="courseYear"
                        label="myroot.yearOfStudy"
                        fullWidth
                    />
                    <DateInput
                        source="startDate"
                        label="myroot.startDate"
                        views={["year", "month"]}
                        fullWidth
                    />
                    <DateInput
                        source="endDate"
                        label="myroot.endDate"
                        views={["year", "month"]}
                        fullWidth
                    />
                        

                        */}
                        <FormDataConsumer>
                            {({ getSource, formData }) =>
                                <Box display="flex" width={1}>
                                    <Box flex={4}>
                                        <TextInput
                                            source={getSource("academicSession")}
                                            label="myroot.academicSession"
                                            fullWidth
                                        />
                                    </Box>
                                    <Box flex={2} ml="0.5em">
                                        <DateInput
                                            source={getSource("startDate")}
                                            label="myroot.startDate"
                                            fullWidth
                                        />
                                    </Box>
                                    <Box flex={2} ml="0.5em">
                                        <DateInput
                                            source={getSource("endDate")}
                                            label="myroot.endDate"
                                            fullWidth
                                        />
                                    </Box>
                                </Box>
                            }
                        </FormDataConsumer>
                        {/*<TextInput
                        source="academicSession"
                        label="myroot.academicSession"
                        fullWidth
            /> TODO: Remove from api and graphql 
            */}
                    </SimpleFormIterator>
                </ArrayInput>
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Status / Franchise" /></b></Divider>
                    </Box>
                </Box>
                <Box display="flex" width={1}>
                    <Box flex={5}>
                        <ReferenceInput reference="Status" source="statusId">
                            <AutocompleteInput optionText="Title" fullWidth />
                        </ReferenceInput>
                    </Box>
                    <Box flex={5} ml="0.5em" justifyContent="flex-end">
                        <BooleanInput source="franchise" label="myroot.franchise" fullWidth />
                    </Box>
                </Box>

            </SimpleForm>
        </ReadOnlyContext.Provider>
    );
};

const useGetCourse = (isAssociateCourse, courseCode) => {
    const dataProvider = useDataProvider();
    const [course, setCourse] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();

    useEffect(() => {
        const courseResource = isAssociateCourse ? 'AssociateCourse' : 'Course';
        dataProvider
            .getMany(courseResource, { ids: [courseCode] })
            .then((response) => {
                if (response?.data && response?.data.length > 0) {
                    setCourse(response.data[0]);
                }
                setLoading(false);
            })
            .catch((error) => {
                setError(error);
                setLoading(false);
            });
    }, [isAssociateCourse, courseCode]);

    return { loading, error, course };
};

const ModulesSelector = ({ isAssociateCourse, courseCode }) => {
    const { loading, error, course } = useGetCourse(
        isAssociateCourse,
        courseCode
    );

    if (loading) {
        return <Loading />;
    }
    if (error) {
        return <p>Error loading Modules</p>;
    }

    let moduleIds =
        course && course.moduleInfos
            ? course.moduleInfos.map((module) => module.moduleId)
            : null;
    let filter = moduleIds ? { ids: moduleIds } : undefined;

    return (
        <ArrayInput source="modules" fullWidth label={false}>
            <SimpleFormIterator disableReordering fullWidth>
                <FormDataConsumer>
                    {({ getSource, scopedFormData }) =>
                        <Box display="flex" width={1}>
                            <Box flex={4}>
                                <ReferenceInput reference="Module" source={getSource("moduleId")} record={scopedFormData} label="myroot.module" filter={filter}>
                                    <AutocompleteInput optionText={ModuleTitleRenderer} fullWidth />
                                </ReferenceInput>
                            </Box>
                            <Box flex={2} ml="0.5em">
                                <AutocompleteInput source={getSource("type")} record={scopedFormData} choices={[
                                    { id: 'optional', name: 'myroot.optional' },
                                    { id: 'core', name: 'myroot.core' },
                                    { id: 'specified', name: 'myroot.specified' },
                                    { id: 'authorised substitution', name: 'myroot.AuthorisedSubstitution' },
                                    { id: 'additional module', name: 'myroot.AdditionalModule' }
                                ]} label="Type" fullWidth />
                            </Box>
                            {/* <Box flex={2} ml="0.5em">
                                <TextInput source={getSource("year")} record={scopedFormData} label="Year" fullWidth />
                            </Box> */}
                        </Box>
                    }
                </FormDataConsumer>
            </SimpleFormIterator>
        </ArrayInput>
    );
};

const CourseCodeSelector = ({ isAssociateCourse }) => {
    if (isAssociateCourse) {
        return (
            <ReferenceInput reference="AssociateCourse" source="courseCode">
                <AutocompleteInput
                    optionText={CourseTitleRenderer}
                    label="Associate Course"
                />
            </ReferenceInput>
        );
    }

    return (
        <>
            <ReferenceInput reference="Course" source="courseCode">
                <AutocompleteInput optionText={CourseTitleRenderer} label="Course" />
            </ReferenceInput>
        </>
    );
};

const CourseTitleRenderer = choice => `${choice.id} - ${choice.Title}`;

const DeliverySelector = ({ isAssociateCourse, courseCode, isCreate, formData }) => {
    const { loading, error, course } = useGetCourse(
        isAssociateCourse,
        courseCode
    );
    if (loading) {
        return <Loading />;
    }
    if (error) {
        return <p>Error loading Deliveries</p>;
    }
    const courseDeliveries = course?.courseDeliveries;
    if (courseDeliveries && courseDeliveries.length > 0) {

        const deliveryChoices = courseDeliveries.map((courseDelivery) => {
            const {
                durationId,
                modeOfStudyId,
                modeOfDeliveryId,
                campusLocationId,
                theDeliveryInstitutionID,
                quercusCode,
                statusId,
                shortCourse,
            } = courseDelivery;

            return {
                id: toSavedRepresentation(courseDelivery),
                durationId: `${durationId}`,
                modeOfStudyId: `${modeOfStudyId}`,
                modeOfDeliveryId: `${modeOfDeliveryId}`,
                campusLocationId: `${campusLocationId}`,
                theDeliveryInstitutionID: `${theDeliveryInstitutionID}`,
                quercusCode: `${quercusCode}`,
                statusId: `${statusId}`,
                shortCourse: `${shortCourse}`,
            };
        });

        if (!isCreate && (formData != "" || formData != undefined)) {
           
            var deliveryJson = formData.courseDelivery.replaceAll("'","\"");
            var delivery = JSON.parse(deliveryJson);

            var campusLocationId = delivery.campusLocationId;
            var durationId = delivery.durationId;
            var modeOfDeliveryId = delivery.modeOfDeliveryId;
            var modeOfStudyId = delivery.modeOfStudyId;
            var qCode = delivery.quercusCode?.slice(0,7);
            var shortCourse = delivery.shortCourse;            
            var theDeliveryInstitutionID = delivery.theDeliveryInstitutionID;
            var rec = deliveryChoices.find((x) =>   x.campusLocationId == campusLocationId &&
                                                    x.durationId == durationId &&
                                                    x.modeOfDeliveryId == modeOfDeliveryId &&
                                                    x.modeOfStudyId == modeOfStudyId &&
                                                    x.quercusCode == qCode &&
                                                    x.shortCourse.toLowerCase() == shortCourse.toLowerCase() &&                                                   
                                                    x.theDeliveryInstitutionID == theDeliveryInstitutionID
                                            );
           
            
            var recArray = [rec];

            return (
                <RadioButtonGroupInput
                    source="courseDelivery"
                    choices={recArray}
                    label={false}
                    optionText={<DeliveryRenderer />}
                />
            )
        }

        return (
            <RadioButtonGroupInput
                source="courseDelivery"
                choices={deliveryChoices}
                label={false}
                optionText={<DeliveryRenderer />}
            />
        );
    }
    return null;
};

export default CourseInstanceInputs;

